var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18.1",
    style: {
      enableBackground: "new 0 0 18 18.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F6BAB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,2.8C13.6,1,11.5,0.1,9,0.1C6.5,0.1,4.4,1,2.6,2.8C0.9,4.5,0,6.6,0,9.1c0,2.5,0.9,4.6,2.6,6.4 c1.8,1.8,3.9,2.6,6.4,2.6c2.5,0,4.6-0.9,6.4-2.6S18,11.6,18,9.1C18,6.6,17.1,4.5,15.4,2.8z M14.6,14.7C13,16.2,11.2,17,9,17 c-2.2,0-4-0.8-5.6-2.3c-1.5-1.5-2.3-3.4-2.3-5.6c0-2.2,0.8-4,2.3-5.6C5,2,6.8,1.2,9,1.2c2.2,0,4,0.8,5.6,2.3 c1.5,1.5,2.3,3.4,2.3,5.6C16.9,11.3,16.1,13.2,14.6,14.7z M8.1,13.9c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.3,0.1,0.6,0.4,0.8 c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.5,0.4-0.8c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.5-0.4-0.8-0.4 C8.6,13.6,8.3,13.7,8.1,13.9z M8.9,2.4c-1.2,0-2.2,0.4-3.1,1.2C4.9,4.4,4.4,5.5,4.4,6.9c0,0.3,0.1,0.6,0.3,0.8C4.9,7.9,5.2,8,5.5,8 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1-0.6,1.6-0.6c1.5,0,2.2,0.6,2.2,1.9 c0,0.8-0.4,1.4-1.3,1.9c-0.5,0.3-1,0.7-1.4,1.2c-0.4,0.5-0.7,1.1-0.7,1.7c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.1,0.1-0.3,0.3-0.5c0.2-0.2,0.4-0.4,0.6-0.5c1.6-0.9,2.5-2.2,2.5-3.9 c0-1.3-0.4-2.4-1.3-3.1C11.2,2.7,10.1,2.4,8.9,2.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.d71ea1842fda0a231bc50bc60fa1e634.svg";
export { ForwardRef as ReactComponent };